class CartRemoveButton extends HTMLElement {
	constructor() {
		super();
		this.removedOne = false;

		this.addEventListener("click", (event) => {
			event.preventDefault();

			document.querySelectorAll(".cart__checkout-button").forEach((checkoutButton) => {
				checkoutButton.disabled = true;
			});

			const cartItems = this.closest("cart-items") || this.closest("cart-drawer-items");
			const variantId = this.closest(".cart-item").dataset.variantId;
			const quantity = parseInt(this.closest(".cart-item").querySelector(".quantity__input").value);

			cartItems.handleDeposit(this.closest(".cart-item"), variantId, quantity, true);
		});
	}
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
	constructor() {
		super();
		this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status") || document.getElementById("CartDrawer-LineItemStatus");

		const debouncedOnChange = debounce((event) => {
			this.onChange(event);

			document.querySelectorAll(".cart__checkout-button").forEach((checkoutButton) => {
				checkoutButton.disabled = true;
			});
		}, ON_CHANGE_DEBOUNCE_TIMER);

		this.addEventListener("change", debouncedOnChange.bind(this));

		document.querySelectorAll(".cart-drawer .quantity__button").forEach((quantityButton) => {
			quantityButton.addEventListener("click", () => {
				document.querySelectorAll(".cart__checkout-button").forEach((checkoutButton) => {
					checkoutButton.disabled = true;
				});
			});
		});
	}

	cartUpdateUnsubscriber = undefined;

	connectedCallback() {
		this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
			if (event.source === "cart-items") {
				return;
			}
			this.onCartUpdate();
		});
	}

	disconnectedCallback() {
		if (this.cartUpdateUnsubscriber) {
			this.cartUpdateUnsubscriber();
		}
	}

	onChange(event) {
		//this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute("name"));
		const variantId = event.target.dataset.quantityVariantId;
		const quantity = parseInt(event.target.value);
		const quantityDeposit = event.target.value - event.target.dataset.cartQuantity
		this.handleDeposit(event.target, variantId, quantity, false, quantityDeposit);
	}

	onCartUpdate() {
		fetch(`${routes.cart_url}?section_id=main-cart-items`)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, "text/html");

				if (html.querySelector("cart-items") !== null) {
					const sourceQty = html.querySelector("cart-items");
					this.innerHTML = sourceQty.innerHTML;
				}
				setTimeout(()=>{
					const event = new CustomEvent("rerenderCart");
					document.dispatchEvent(event);
				}, 100);
			})
			.catch((e) => {
				console.error(e);
			});
	}

	getSectionsToRender() {
		return [
			{
				id: "main-cart-items",
				section: document.getElementById("main-cart-items").dataset.id,
				selector: ".js-contents",
			},
			{
				id: "cart-icon-bubble",
				section: "cart-icon-bubble",
				selector: ".shopify-section",
			},
			{
				id: "cart-live-region-text",
				section: "cart-live-region-text",
				selector: ".shopify-section",
			},
			{
				id: "main-cart-footer",
				section: document.getElementById("main-cart-footer").dataset.id,
				selector: ".js-contents",
			},
		];
	}

	updateQuantity(line, quantity, name) {
		this.enableLoading(line);

		const body = JSON.stringify({
			line,
			quantity,
			sections: this.getSectionsToRender().map((section) => section.section),
			sections_url: window.location.pathname,
		});

		fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
			.then((response) => {
				return response.text();
			})
			.then((state) => {
				const parsedState = JSON.parse(state);
				const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
				const items = document.querySelectorAll(".cart-item");

				if (parsedState.errors) {
					quantityElement.value = quantityElement.getAttribute("value");
					this.updateLiveRegions(line, parsedState.errors);
					return;
				}

				const cartDrawerWrapper = document.querySelector("cart-drawer");

				setTimeout(()=>{
					const event = new CustomEvent("rerenderCart");
					document.dispatchEvent(event);
				}, 100);

				this.getSectionsToRender().forEach((section) => {
					const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
					elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
				});

				// After the sections are swapped in, so the freshly created elements are covered too.
				window.syncCartEmptyState(parsedState.item_count);
				const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
				let message = "";
				if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
					if (typeof updatedValue === "undefined") {
						message = window.cartStrings.error;
					} else {
						message = window.cartStrings.quantityError.replace("[quantity]", updatedValue);
					}
				}
				this.updateLiveRegions(line, message);

				const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
				if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
					cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
				} else if (parsedState.item_count === 0 && cartDrawerWrapper) {
					trapFocus(cartDrawerWrapper.querySelector(".drawer__inner-empty"), cartDrawerWrapper.querySelector("a"));
				} else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
					trapFocus(cartDrawerWrapper, document.querySelector(".cart-item__name"));
				}
				publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
			})
			.catch(() => {
				this.querySelectorAll(".loading-overlay").forEach((overlay) => overlay.classList.add("hidden"));
				const errors = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
				errors.textContent = window.cartStrings.error;
			})
			.finally(() => {
				this.disableLoading(line);
			});
	}

	updateItem(variantId, depositVariantId, variantQuantity, depositQuantity, customCartItemsObj) {
		let updates;

		if (customCartItemsObj !== null) {
			updates = customCartItemsObj;
		} else {
			if (depositVariantId) {
				const depositDiscountEl = document.querySelector(`.has-discount.deposit[data-variant-id="${depositVariantId}"]`);
				const discountLineId = depositDiscountEl?.dataset?.lineId;

				const nonDiscountEl = document.querySelector(`.deposit[data-variant-id="${depositVariantId}"]:not(.has-discount)`);
				const nonDiscountLineId = nonDiscountEl?.dataset?.lineId;

				if (depositDiscountEl && discountLineId) {
					// Deposit is split across two lines. Zero out the discounted line and set
					// the full amount on the non-discounted line. Shopify re-applies the discount.
					updates = { [discountLineId]: 0 };
					if (nonDiscountLineId) updates[nonDiscountLineId] = depositQuantity;
					if (variantId) updates[variantId] = variantQuantity;
				} else {
					// Single deposit line — use line ID if available, otherwise variant ID.
					const depositLineId = nonDiscountLineId || depositVariantId;
					if (variantId) {
						updates = { [depositLineId]: depositQuantity, [variantId]: variantQuantity };
					} else {
						updates = { [depositLineId]: depositQuantity };
					}
				}
			} else {
				updates = {
					[variantId]: variantQuantity,
				};
			}
		}


		fetch(window.Shopify.routes.root + "cart/update.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ updates }),
		})
			.then((response) => response.json())
			.then(() => {
				window.refreshCartDrawer();
			});
	}

	changeItem(lineIndex, variantQuantity, sellingPlanId, depositVariantId, depositQuantity) {
		const cartItems = this.closest("cart-items") || this.closest("cart-drawer-items");
		let cartItem;

		cartItem = {
			line: lineIndex,
			quantity: variantQuantity,
		};

		if (sellingPlanId) {
			cartItem.selling_plan = parseInt(sellingPlanId);
		}

		fetch(window.Shopify.routes.root + "cart/change.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(cartItem),
		}).then(() => {
			cartItems.updateItem(null, depositVariantId, null, depositQuantity, null);
		});
	}

	updateLiveRegions(line, message) {
		const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
		if (lineItemError) lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

		this.lineItemStatusElement.setAttribute("aria-hidden", true);

		const cartStatus = document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
		cartStatus.setAttribute("aria-hidden", false);

		setTimeout(() => {
			cartStatus.setAttribute("aria-hidden", true);
		}, 1000);
	}

	getSectionInnerHTML(html, selector) {
		return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
	}

	enableLoading(line) {
		const mainCartItems = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
		mainCartItems.classList.add("cart__items--disabled");

		const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
		const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

		[...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove("hidden"));

		document.activeElement.blur();
		this.lineItemStatusElement.setAttribute("aria-hidden", false);
	}

	disableLoading(line) {
		const mainCartItems = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
		mainCartItems.classList.remove("cart__items--disabled");

		const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
		const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

		cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
		cartDrawerItemElements.forEach((overlay) => overlay.classList.add("hidden"));
	}

	handleDeposit(element, variantId, quantity, removeItem, differnanceAmountDeposit) {
		const cartItems = this.closest("cart-items") || this.closest("cart-drawer-items");
		let totalQuantity = 0;
		let depositHasReference = false;
		let hasSellingPlanItems = false;

		// calculate totalQuantity
		cartItems.querySelectorAll(".cart-item").forEach((cartItem) => {
			let cartItemQuantity = cartItem.dataset.depositAmount || 0;
			totalQuantity += parseInt(cartItem.querySelector('input').value) * cartItemQuantity;
		});

		fetch("/cart.json")
			.then((response) => response.json())
			.then((cart) => {
				cart.items.forEach((item) => {
					// check for deposit reference
					if (item.variant_id === parseInt(element.closest(".cart-item").dataset.depositId)) {
						depositHasReference = true;
					}

					if (item.selling_plan_allocation !== undefined) {
						hasSellingPlanItems = true;
					}
				});

				if (element.closest(".cart-item").dataset.depositId && depositHasReference) {
					let depositProcessed = false;
					cartItems.querySelectorAll(".cart-item").forEach((cartItem) => {
						if (depositProcessed) return;
						if (cartItem.classList.contains("deposit")) {
							if (element.closest(".cart-item").dataset.depositId === cartItem.dataset.variantId) {
								depositProcessed = true;
								const depositVariantId = cartItem.dataset.depositId;
								let depositQuantity;

								if (removeItem) {
									depositQuantity = totalQuantity - (element.closest('.cart-item').dataset.depositAmount * element.querySelector('input').value);
									cartItems.updateItem(variantId, depositVariantId, 0, depositQuantity, null);
								} else {
									depositQuantity = totalQuantity;

									if (hasSellingPlanItems) {
										let sellingPlanId = element.closest(".cart-item").dataset.sellingPlanId;
										let lineIndex = element.closest(".cart-item").dataset.lineIndex;

										cartItems.changeItem(lineIndex, quantity, sellingPlanId, depositVariantId, depositQuantity);
									} else {
										cartItems.updateItem(variantId, depositVariantId, quantity, depositQuantity, null);
									}
								}
							}
						}
					});
				} else {
					if (removeItem && !depositHasReference) {
						cartItems.updateItem(variantId, null, 0, 0, null);
					} else {
 						cartItems.updateItem(variantId, null, quantity, 0, null);
					}
				}
			});
	}

	watchDepositCartItems() {
		const cartItems = document.querySelector(".cart-drawer .cart-items");
		const arrayOfDepositIdsObj = [];
		let updates = {};

		if (cartItems !== null) {
			const processedDepositIds = new Set();

			cartItems.querySelectorAll(".cart-item:not(.selling-plan)").forEach((cartItem) => {
				const depositId = cartItem.dataset.depositId;
				const quantity = cartItem.dataset.quantity;

				if (depositId !== undefined && !processedDepositIds.has(depositId)) {
					arrayOfDepositIdsObj.push({
						depositId: depositId,
						quantity: cartItem.dataset.depositAmount,
					});

					processedDepositIds.add(depositId);
				}
			});

			cartItems.querySelectorAll(".cart-item:not(.selling-plan)").forEach((cartItem) => {
				const variantId = cartItem.dataset.variantId;
				const index = arrayOfDepositIdsObj.map((element) => element.depositId).indexOf(variantId.toString());

				if (index !== -1) {
					arrayOfDepositIdsObj.splice(index, 1);
				}
			});

			if (arrayOfDepositIdsObj.length > 0) {
				arrayOfDepositIdsObj.forEach((depositId) => {
					updates[depositId.depositId] = depositId.quantity;
				});

				document.querySelectorAll(".cart__checkout-button").forEach((checkoutButton) => {
					checkoutButton.disabled = true;
				});

				this.updateItem(null, null, null, null, updates);
			}
		}
	}
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
	customElements.define(
		"cart-note",
		class CartNote extends HTMLElement {
			constructor() {
				super();

				this.addEventListener(
					"change",
					debounce((event) => {
						const body = JSON.stringify({ note: event.target.value });
						fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
					}, ON_CHANGE_DEBOUNCE_TIMER),
				);
			}
		},
	);
}

const CartItemsClass = new CartItems();

document.addEventListener("DOMContentLoaded", () => {
	//CartItemsClass.watchDepositCartItems();
});

document.addEventListener("rerenderCart", () => {
	//CartItemsClass.watchDepositCartItems();
});
